export class ClientEmployeeContactBO
{
    Id:string
    ContactType:string
    type:string
}

export class ContactInfoLst {
    id:  string="00000000-0000-0000-0000-000000000000";
    name: string;
    street: string;
    city: string;
    state: string;
    zipCode: string;
    county: string;
    phoneNumber: string;
    alternatePhoneNumber: string;
    fax: string;
    email: string;
    contactTypeLid:  string="00000000-0000-0000-0000-000000000000";
    relationshipLid: string | null;
    phoneCarrierLid: string | null;
    employeeId: string | null;
    clientId: string | null;
    contactTypeName: string;
    relationshipName: string;
    phoneCarrierName: string;
    showAdditionalDetails: boolean = false;
    referralId : string;
}


export class functionpermissionemployee {
    employeecreate: boolean = true;
    employeeupdate: boolean = true;
    payorrequiredcreate: boolean = true;
    payorrequireddelete: boolean = true;
    payorrequiredupdate: boolean = true;
    payratescreate: boolean = true;
    payratesdelete: boolean = true;
    payratesupdate: boolean = true;
    payrollinfocreate: boolean = true
    payrollinfoupdate: boolean = true
    payrollinfosave: boolean = true
    employeenotescreate: boolean = true
    employeenotesupdate: boolean = true
    employeenotesdelete: boolean = true
    payratecreate: boolean = true
    payrateupdate: boolean = true
    payratedelete: boolean = true
    contactcreate: boolean = true;
    contactupdate: boolean = true;
    contactdelete: boolean = true;
    employeedocumentcreate: boolean = true
    employeedocumentupdate: boolean = true
    employeerelationshipcreate: boolean = true
    employeerelationshipupdate: boolean = true
}